import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import Lenis from 'lenis';

// Start Stimulus application
const application = Application.start()
const context = require.context('./controllers', true, /\.js$/)
application.load(definitionsFromContext(context));
application.debug = process.env.NODE_ENV === 'development';

import './css/app.scss';

// Automatically add all images to the manifest.json
const imagesCtx = require.context('./images', false, /\.(png|jpg|jpeg|gif|ico|svg|webp)$/);
imagesCtx.keys().forEach(imagesCtx);

// scrollbarWidth.js
const calculateScrollbarWidth = (function calculateScrollbarWidth() {
    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');

    return calculateScrollbarWidth;
})();

document.addEventListener('DOMContentLoaded', calculateScrollbarWidth); 
window.addEventListener('resize', calculateScrollbarWidth);
window.addEventListener('load', calculateScrollbarWidth);
document.documentElement.addEventListener('turbo:render', calculateScrollbarWidth);
document.documentElement.addEventListener('turbo:frame-render', calculateScrollbarWidth);

// Lenis
const lenis = new Lenis();

(function raf(time) {
    lenis.raf(time);
    window.requestAnimationFrame(raf);
    return raf;
})();

document.documentElement.addEventListener('turbo:render', () => lenis.resize());
document.documentElement.addEventListener('turbo:frame-render', () => lenis.resize());

(function menuRaf(time) {
    const narr = document.querySelector('.mod_article.article--top-creators-2025-narrative');
    const jury = document.querySelector('.mod_article.article--top-creators-2025-jury');

    if (narr && jury) {
        const nr = narr.getBoundingClientRect();
        const jr = jury.getBoundingClientRect();

        if (nr.top < window.innerHeight * 0.85 && (jr.top + jr.height) > window.innerHeight * 0.15) {
            document.body.classList.add('top-creators-2025-blur');
        } else {
            document.body.classList.remove('top-creators-2025-blur');
        }
    }

    const menu = document.getElementById('top-creators-2025-menu');

    if (menu) {
        const links = menu.querySelectorAll('a');

        links.forEach((link) => {
            link.classList.remove('active');
            const url = new URL(link.href);

            if (!url.hash) {
                return;
            }

            const article = document.getElementById(url.hash.substring(1));

            if (article && article.getBoundingClientRect().top <= window.innerHeight * 0.2) {
                links.forEach(link => link.classList.remove('active'));
                link.classList.add('active');
            }
        });
    }

    window.requestAnimationFrame(menuRaf);
    return menuRaf;
})();
